var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classes},[_c('b',[_c('stock-view',{attrs:{"amount":_vm.stockOnHand,"short":_vm.noText,"unit":_vm.unit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }